import { useSearchParams } from 'react-router-dom';
import { Tabs } from '@/components/ui';
import { canView } from '@/shared/lib/permissions';
import { useAuthStore } from '@/shared/stores/auth';
import { Ivr } from './Ivr';
import { Queues } from './Queues';
import { BlockedNumbers } from './BlockedNumbers';

/**
 * מסך טלפוניה אחד: IVR / תורים / חסומים בלשוניות (/admin/telephony).
 * הנתיבים הישנים /admin/ivr, /admin/queues ו-/admin/blocked-numbers מפנים
 * לכאן עם הלשונית. הסוכן הקולי הוסר ממרכזיות (07/09/2026, דורון) — נשאר
 * רק אצל הסופר-אדמין (/super/voice).
 * לשונית מוצגת רק למי שיש לו הרשאת צפייה במסך המקורי (RBAC) —
 * השרת אוכף ממילא על ה-API.
 */
// המספרים (DID) קיבלו פריט תפריט משלהם (/admin/dids); כאן שאר הטלפוניה.
const ALL_TABS = [
  { id: 'ivr', label: 'IVR', perm: 'ivr' },
  { id: 'queues', label: 'תורים', perm: 'queues' },
  { id: 'blocked', label: 'חסומים', perm: 'telephony' },
];

export function TelephonyCenter() {
  const [params, setParams] = useSearchParams();
  const user = useAuthStore((s) => s.user);
  const tabs = ALL_TABS.filter((t) => canView(user, t.perm));
  const requested = params.get('tab') ?? 'ivr';
  const tab = tabs.some((t) => t.id === requested) ? requested : (tabs[0]?.id ?? 'ivr');

  // עיצוב v2: הלשוניות יושבות בשורה אחת עם הכפתור הראשי של הלשונית —
  // לכן הן מועברות פנימה, וכל לשונית מציבה אותן בסרגל הפתיחה שלה.
  const tabsNode = (
    <Tabs
      items={tabs}
      value={tab}
      onChange={(id) => setParams(id === 'ivr' ? {} : { tab: id }, { replace: true })}
    />
  );

  return (
    <>
      {tab === 'ivr' && <Ivr tabs={tabsNode} />}
      {tab === 'queues' && <Queues tabs={tabsNode} />}
      {tab === 'blocked' && <BlockedNumbers tabs={tabsNode} />}
    </>
  );
}
